import CameraAsset from "@/assets/illustrations/camera.webp";
import UsersAsset from "@/assets/illustrations/users.webp";
import EyeAsset from "@/assets/images/report/glass/eye.webp";
import type { CampaignTypeSlug } from "@/components/campaign/ai/campaignTypes";

/** A static image require() resolves to a Metro module id at build time. */
type IllustrationSource = number;

export type FormatCardBadge = "popular" | "recommended";

export type FormatCardData = {
  slug: CampaignTypeSlug;
  /** Glass 3D render (white/silver) — only has contrast on the purple
   * gradient tile; never place it directly on the white card background. */
  illustration: IllustrationSource;
  /** Literal size classes for the compact (1a) tile's illustration — classes
   * rather than px numbers because the shared `Image` drops the `style` prop
   * and the Tailwind JIT needs the literals in a scanned file. */
  illustrationClass: string;
  /** Same, for the large (1b) tile — not a fixed ratio of the compact size,
   * so both are spelled out per the design spec. */
  illustrationClassLarge: string;
  title: string;
  /** 1a card copy. */
  compactDescription: string;
  /** 1b card copy. */
  largeDescription: string;
  /** Badge shown on the compact (1a) card, if any. The large (1b) grid never
   * shows badges — Montu AI does the choosing there, nothing to recommend. */
  badgeCompact?: FormatCardBadge;
};

/**
 * Shared copy for both format-card grids (1a compact / 1b large). Slugs match
 * `CampaignTypeSlug` since clicking a card deep-links straight into
 * `/campaign/ai?type=<slug>` — the same contract `MontuAiLauncher` uses.
 * No metrics/pricing rows by design.
 */
export const FORMAT_CARDS: FormatCardData[] = [
  {
    slug: "ugc",
    illustration: CameraAsset,
    illustrationClass: "h-[42px] w-[42px]",
    illustrationClassLarge: "h-[50px] w-[50px]",
    title: "UGC Ads",
    compactDescription: "Videos de creadores, listos para tus ads.",
    largeDescription:
      "Videos de creadores, listos para tus ads. Los usas en Meta, TikTok o tu tienda.",
    badgeCompact: "popular",
  },
  {
    slug: "organic",
    illustration: UsersAsset,
    illustrationClass: "h-[42px] w-[42px]",
    illustrationClassLarge: "h-[50px] w-[50px]",
    title: "Orgánico",
    compactDescription: "Publicaciones en las cuentas de los creadores.",
    largeDescription:
      "Publicaciones en las cuentas de los creadores. Alcance real, audiencia propia.",
  },
  {
    slug: "meliclips",
    illustration: EyeAsset,
    illustrationClass: "h-[42px] w-[42px]",
    illustrationClassLarge: "h-[50px] w-[50px]",
    title: "Meliclips",
    compactDescription: "Videos para Mercado Libre.",
    largeDescription: "Videos UGC para tus productos en Mercado Libre.",
  },
];
